import { NgModule } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { CommonComponentsModule } from "components/common/common-components.module";
import { ComponentsModule } from "components/components.module";
import { EPrescribeComponentModule } from "components/eprescribe/eprescribe.component.module";
import { IonicPageModule } from "ionic-angular";
import { TruncateModule } from "ng2-truncate";
import { EPrescribePage } from "./eprescribe";

@NgModule({
  entryComponents: [],
  declarations: [EPrescribePage],
  imports: [
    IonicPageModule.forChild(EPrescribePage),
    TranslateModule.forChild(),
    CommonComponentsModule,
    NgSelectModule,
    ComponentsModule,
    TruncateModule,
    EPrescribeComponentModule,
  ],
  exports: [EPrescribePage],
})
export class EPrescribePageModule {}



// WEBPACK FOOTER //
// ./src/pages/eprescribe/eprescribe.module.ts